export default __webpack_public_path__ + "static/media/nantes12.4b5f8f29.jpg";